/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import queryString from "query-string";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Box, Button as MuiButton } from "@mui/material";
import { Helmet } from "react-helmet";
import ReloadIcon from "../../assets/svg/ReloadIcon";
import AppliedFilter from "../../components/common/AppliedFilter/AppliedFilter";
import Loader from "../../components/common/Loader/Loader";
import Modal from "../../components/common/Modal/Modal";
import Pagination from "../../components/common/new/Pagination/Pagination";
import useUserConfig from "../../hooks/useUserConfig";
import {
  AppliedFilterLabelMap,
  DATES,
  EVENT_NAME,
  ACTIVE,
  Constants,
  AlertStatus,
} from "../../contants";
import useQueryParams from "../../hooks/useQueryParams";
import { SET_SELECTED_MEMBER_TRANSFER } from "../../redux/actionTypes/dashboard";
import { selectOSKeysByUserRole } from "../../redux/selectors/user";
import Member from "../../services/api/member";
import { ROUTES } from "../../utils/constants";
import { formDataToObject, isEmptyObj } from "../../utils/helper";
import styles from "./GraduationSearch.styles";
import MemberTable from "./GraduationTable/GraduationTable";
import MemberToggleStatus from "./GraduationToggleStatus/GraduationToggleStatus";
import OrganizationSearch from "./OrganizationSearch";
import PersonalDetailsSearch from "./PersonalDetailsSearch";
import {
  getDivisionRoutePath,
  getFilters,
  getFormattedGraduationQuery,
  getFormattedQuery,
  getGraduationRoutePath,
  getRoutePath,
  handleDependencyFilter,
  performOperation,
} from "./utils";
import Button from "../../components/common/Button";
import { CommonStyles } from "../../components/common/Button/commonButtonStyle";
import AutoCompleteDropdown from "../../components/common/new/AutoCompleteDropdown/AutoCompleteDropdown";
import Typography from "../../components/common/new/Typography/Typography";
import SpecialGroup from "../../services/api/SpecialGroup";
import { ToastAlertContext } from "../../config/providers/ToastAlert";
import IntroductionForm from "../../services/api/introductionForm";
import { getOptions } from "../../utils";
import {
  SET_DIVISIONS,
  SET_SPECIAL_GROUP,
  SET_SUB_DIVISIONS,
} from "../../redux/actionTypes/meta";
import AppliedFilterGrad from "./Components/AppliedFilter/AppliedFilter";
import Toast from "../../components/common/Toast";

const LOADER_DELAY = 1000;
const PAGE = "page";

const DIVISION_OPTIONS = [
  {
    displayName: "FD Cubs (G) - FD YP (G)",
    divisionId: 53,
    subdivisionId: 7,
    divisionIdFrom: 7,
    divisionIdTo: 9,
    value: "FD(G)_Cubs-YP",
  },
  {
    displayName: "FD YP (G) - FD YL (G)",
    divisionId: 53,
    subdivisionId: 9,
    divisionIdFrom: 9,
    divisionIdTo: 11,
    value: "FD(G)_YP-YL",
  },
  {
    displayName: "FD YL (G) - YWD Student",
    divisionId: 53,
    subdivisionId: 11,
    divisionIdFrom: 11,
    divisionIdTo: 58,
    value: "FD(G)_YL-YWD",
  },
  {
    displayName: "YWD Student - YWD",
    divisionId: 3,
    subdivisionId: 58,
    divisionIdFrom: 58,
    divisionIdTo: 3,
    value: "YWD_Student-Graduation",
  },
  {
    displayName: "YWD - WD",
    divisionId: 3,
    divisionIdFrom: 3,
    divisionIdTo: 2,
    value: "YWD_WD",
  },
  {
    displayName: "FD Cubs (B) - FD YP (B)",
    divisionId: 52,
    subdivisionId: 54,
    divisionIdFrom: 54,
    divisionIdTo: 55,
    value: "FD(B)_Cubs-YP",
  },
  {
    displayName: "FD YP (B) - FD YL (B)",
    divisionId: 52,
    subdivisionId: 55,
    divisionIdFrom: 55,
    divisionIdTo: 56,
    value: "FD(B)_YP-YL",
  },
  {
    displayName: "FD YL (B) - YMD Student",
    divisionId: 52,
    subdivisionId: 56,
    divisionIdFrom: 56,
    divisionIdTo: 57,
    value: "FD(B)_YL-YMD",
  },
  {
    displayName: "YMD Student - YMD",
    divisionId: 37,
    subdivisionId: 57,
    divisionIdFrom: 57,
    divisionIdTo: 37,
    value: "YMD_Student_Graduation",
  },
  {
    displayName: "YMD - MD",
    divisionId: 37,
    divisionIdFrom: 37,
    divisionIdTo: 1,
    value: "YMD_MD",
  },
];

const getDivision = (selectedDivisionId) =>
  DIVISION_OPTIONS.find((div) => div.value === selectedDivisionId);

const intialPaginationState = {
  currentPage: 0,
  totalPages: 0,
  totalElements: 0,
  pageSize: Constants.DEFAULT_PAGE_SIZE,
};

const filterOrder = [
  "areaId",
  "clusterId",
  "zoneId",
  "regionId",
  "chapterId",
  "districtId",
  "blockId",
];

function InductionSearch({ isGraduation, isDivision }) {
  const TITLE = isGraduation
    ? "Graduation Search - BSG"
    : isDivision
    ? "Division Graduation Search - BSG"
    : "Induction Search - BSG";

  const [searchData, setSearchData] = useState([]);
  const [inductionData, setInductionData] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [paginationInfo, setPaginationInfo] = useState(intialPaginationState);
  const [isLoading, setIsLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openResultModal, setOpenResultModal] = useState(false);
  const allowModalRef = useRef(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false
  );

  const formRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const metaData = useSelector((state) => state.meta);
  const disabledOSKeys = useSelector(selectOSKeysByUserRole);
  const hasPermission = useUserConfig();
  const [university, setUniversity] = useState([]);
  const [inductionDate, setInductionDate] = useState([]);
  const toast = useContext(ToastAlertContext);
  const { getQueryObject, getQueryParams, urlSearchParams } = useQueryParams();
  const [memberName, setMemberName] = useState("");
  const [editCollegeName, setEditCollegeName] = useState("");
  const [method, setMethod] = useState([]);
  const [specialGroup, setSpecialGroup] = useState([]);
  const [specialGroupVal, setSpecialGroupVal] = useState("");
  const [universityVal, setUniversityVal] = useState("");
  const [subDivision, setSubDivision] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("");
  const [inputFullName, setFullName] = useState("");
  const [inputmemberId, setInputMemberId] = useState("");
  const [divisionVal, setDivisionVal] = useState("");
  const [divisions, setDivisions] = useState([]);
  const [showToast, setShowToast] = useState(null);

  useEffect(() => {
    const onResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const setMetaDataInRedux = (type, payload) => {
    dispatch({
      type,
      payload,
    });
  };

  const getDivisions = async () => {
    const response = await IntroductionForm.getDivisions();
    const filteredData = response.data.filter(
      (item) => item.divisionId !== 52 && item.divisionId !== 53
    );
    setDivisions(filteredData);
    setMetaDataInRedux(SET_DIVISIONS, filteredData);
  };

  const onModalToggle = () => setOpenModal((prev) => !prev);

  const getUniversity = async () => {
    const response = await IntroductionForm.getUniversity();
    setUniversity(response.data);
  };

  const getSpecialGroup = async (divisionId) => {
    const response = await SpecialGroup.getDivisionSpecialGroup({ divisionId });
    setSpecialGroup(response.data);
    setMetaDataInRedux(SET_SPECIAL_GROUP, response.data);
  };

  const onSelectionHandler = (checked, memberId, fullName) => {
    if (checked) {
      setMethod((prev) => [...prev, { memberId, fullName }]);
    } else {
      setMethod([]);
      setEditCollegeName("");
      setSubDivision("");
      setUniversityVal("");
    }
  };

  const checkAllToggle = (checked) => {
    if (checked && searchData.length) {
      setMethod(
        searchData.map((member) => ({
          memberId: member.memberId,
          fullName: member.fullName,
        }))
      );
    } else {
      setMethod([]);
      setEditCollegeName([]);
      setSubDivision([]);
      setUniversityVal([]);
    }
  };

  const handleDateChange = (newValue, index, item) => {
    const selectedItemIndex = method.findIndex(
      (date) => date.memberId === item.memberId
    );
    const formatDate = `${newValue.$y}-${(newValue.$M + 1)
      .toString()
      .padStart(2, "0")}-${newValue.$D.toString().padStart(2, "0")}`;

    const newItem = {
      memberId: item.memberId,
      inductionDate: formatDate,
      fullName: item.fullName,
    };

    const graduationNewItems = {
      memberId: item.memberId,
      graduationDate: formatDate,
      fullName: item.fullName,
    };
    const newDates = [...method];
    newDates[selectedItemIndex] =
      isGraduation === true ? graduationNewItems : newItem;

    const newInductionDate = [...inductionDate];
    newInductionDate[index] = newValue;

    setMethod(newDates);
    setInductionDate(newInductionDate);
  };

  const onChangeInput = (
    e,
    memberId,
    fullName,
    selectedUniversity,
    selectedSubDivision,
    index
  ) => {
    const { value } = e.target;
    setMemberName(value);

    if (value !== null) {
      const updatedValues = [...universityVal];
      updatedValues[index] = value;
      setUniversityVal(updatedValues);

      const updatedDivisionVal = [...subDivision];
      updatedDivisionVal[index] = value;
      setSubDivision(updatedDivisionVal);

      const updatedCollegeName = [...editCollegeName];
      updatedCollegeName[index] = value;
      setEditCollegeName(updatedCollegeName);
    }

    if (isDivision === true) {
      const updatedName = searchData.map((member) => {
        if (member.memberId === memberId) {
          return {
            ...member,
            fullName: value,
          };
        }
        return member;
      });

      setMethod((prevMethod) =>
        prevMethod.map((item) =>
          item.memberId === memberId
            ? {
                ...item,
                fullName: value,
              }
            : item
        )
      );
      setSearchData(updatedName);
    } else {
      setSearchData((prevSearchData) =>
        prevSearchData.map((item) =>
          item.memberId === memberId ? { ...item, fullName } : item
        )
      );
    }
  };

  const updatePaginationInfo = (pagination) => {
    setPaginationInfo({
      currentPage: pagination.number,
      totalPages: pagination.totalPages,
      totalElements: pagination.totalElements,
      pageSize: pagination.size,
    });
  };

  const clearFormRef = () => {
    Object.keys(AppliedFilterLabelMap).forEach((key) => {
      if (formRef.current[key]) {
        formRef.current[key].value = "";
        formRef.current[key]?.blur();
      }
    });
  };

  useEffect(() => {
    getUniversity();
  }, []);

  useEffect(() => {
    if (divisions.length && divisionVal) {
      getSpecialGroup(divisionVal);
    }
  }, [divisions, divisionVal]);

  const resetFormState = () => {
    setSearchData([]);
    setAppliedFilters([]);
    setPaginationInfo(intialPaginationState);
    clearFormRef();
    setDivisionVal("");
    setSpecialGroupVal("");
    setSelectedDivision("");
    setInputMemberId("");
    setFullName("");
  };

  const initializeFormState = (queryObject) => {
    if (!isEmptyObj(queryObject)) {
      clearFormRef();
      Object.keys(queryObject).forEach((key) => {
        if (formRef.current[key]) {
          formRef.current[key].value = queryObject[key];
        }
      });
    }
  };

  const updateSearchParam = (query) => {
    if (query?.length) {
      if (isGraduation === true) {
        navigate(`${getGraduationRoutePath()}?${query}`);
      } else if (isDivision === true) {
        navigate(`${getDivisionRoutePath()}?${query}`);
      } else navigate(`${getRoutePath()}?${query}`);
    } else if (isGraduation === true) {
      navigate(`${getGraduationRoutePath()}`);
    } else if (isDivision === true) {
      navigate(`${getDivisionRoutePath()}`);
    } else navigate(`${getRoutePath()}`);
  };

  const removeKeyFromQuery = (queryObject, filterKey) => {
    let updatedQuery = { ...queryObject, page: 0 };

    if (DATES.includes(filterKey)) {
      delete updatedQuery[filterKey];
      delete updatedQuery[`${filterKey.split("From")[0]}To`];
    } else {
      delete updatedQuery[filterKey];
    }

    if (Object.keys(updatedQuery).length === 1 && PAGE in updatedQuery) {
      delete updatedQuery[PAGE];
    }

    if (disabledOSKeys && Array.isArray(disabledOSKeys)) {
      updatedQuery = handleDependencyFilter(updatedQuery, disabledOSKeys);
    }

    return updatedQuery;
  };

  const onRemoveFilter = (filterKey) => {
    setPaginationInfo(intialPaginationState);
    let queryObject = getQueryObject();
    queryObject = removeKeyFromQuery(queryObject, filterKey);
    const updatedQuery = queryString.stringify(queryObject);
    updateSearchParam(updatedQuery);
  };

  const hasAnyRealFilter = (q) => {
    if (!q || isEmptyObj(q)) return false;
    return Object.entries(q).some(
      ([k, v]) =>
        !["page", "pageSize"].includes(k) &&
        v !== undefined &&
        String(v).trim() !== ""
    );
  };

  const fetchSearchData = async (queryParams, params = {}) => {
    const validation = () => {
      if (isDivision !== true && !specialGroupVal) {
        return "Please select a Special group.";
      }
      if (isDivision === true && !selectedDivision) {
        return "Please select a division.";
      }
      return "";
    };

    try {
      const error = validation();
      if (error) throw new Error(error);
      setIsLoading(true);
      const formattedGraduationQuery = getFormattedGraduationQuery(queryParams);
      const formattedDivisionGraduationQuery = getFormattedQuery(queryParams);

      const { data } =
        isGraduation === true
          ? await Member.searchInduction(formattedGraduationQuery, params)
          : isDivision === true
          ? await Member.search(formattedDivisionGraduationQuery, params)
          : await Member.specialGroupMemberSearch(
              formattedGraduationQuery,
              params
            );

      setTimeout(() => {
        setInductionData(data.content);
        setSearchData(data.content);
        updatePaginationInfo(data);
        setIsLoading(false);

        if (data.content?.length > 0) {
          if (allowModalRef.current) {
            setOpenResultModal(true);
            allowModalRef.current = false;
          }
        } else {
          setShowToast({
            severity: "error",
            message: "No data found",
          });
          setOpenResultModal(false);
          allowModalRef.current = false;
        }
      }, LOADER_DELAY);
    } catch (error) {
      setIsLoading(false);
      toast.show(error.message, AlertStatus.ERROR);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setPaginationInfo(intialPaginationState);

    const rawFormData = new FormData(formRef.current);
    let formData = formDataToObject(rawFormData);

    if (!isDivision && specialGroupVal) {
      formData.specialGroupId = specialGroupVal;
    } else if (isDivision && selectedDivision) {
      const { divisionId, subdivisionId } = getDivision(selectedDivision);
      formData = {
        ...formData,
        divisionId,
        ...(inputFullName ? { fullName: inputFullName } : {}),
        ...(inputmemberId ? { memberId: inputmemberId } : {}),
        ...(subdivisionId ? { subdivisionId } : {}),
      };
    }

    const hasFilter = Object.values(formData).some(
      (val) => val && String(val).trim() !== ""
    );
    if (!hasFilter) {
      setShowToast({
        severity: "warning",
        message: "Please select your search filter",
      });
      return;
    }

    const query = queryString.stringify(formData);
    document.dispatchEvent(new Event(EVENT_NAME));

    allowModalRef.current = true;

    updateSearchParam(query);
  };

  useEffect(() => {
    const queryObject = getQueryObject();

    if (isEmptyObj(queryObject)) {
      resetFormState();
      setOpenResultModal(false);
      allowModalRef.current = false;
      return;
    }

    if (!hasAnyRealFilter(queryObject)) {
      resetFormState();
      setOpenResultModal(false);
      allowModalRef.current = false;
      if (
        queryObject.page !== undefined ||
        queryObject.pageSize !== undefined
      ) {
        updateSearchParam();
      }
      return;
    }

    const [query, params] = getQueryParams(queryObject);
    fetchSearchData(query, params);
    initializeFormState(query);
    setMethod([]);
    setEditCollegeName("");
    setSubDivision("");
    setUniversityVal("");
    setMemberName("");
  }, [urlSearchParams.toString()]);

  useEffect(() => {
    const queryObject = getQueryObject();
    if (
      !isEmptyObj(queryObject) &&
      metaData &&
      disabledOSKeys &&
      Array.isArray(disabledOSKeys) &&
      hasAnyRealFilter(queryObject)
    ) {
      const query = getQueryParams(queryObject)[0];
      try {
        setAppliedFilters(
          getFilters(query, metaData, disabledOSKeys, isDivision)
        );
      } catch (err) {
        // console.error("Error in getFilters:", err);
        setAppliedFilters([]);
      }
    } else {
      setAppliedFilters([]);
    }
  }, [metaData, disabledOSKeys, urlSearchParams.toString()]);

  const onPaginationClick = (clickedNumber) => {
    const queryObject = getQueryObject();
    const queryParams = queryString.stringify({
      ...queryObject,
      page: clickedNumber,
    });
    updateSearchParam(queryParams);
  };

  const onPageSizeClick = (operator) => {
    const queryObject = getQueryObject();
    const queryParams = queryString.stringify({
      ...queryObject,
      page: 0,
      pageSize: queryObject.pageSize
        ? performOperation(
            queryObject.pageSize,
            Constants.DEFAULT_PAGE_SIZE,
            operator
          )
        : 2 * Constants.DEFAULT_PAGE_SIZE,
    });
    updateSearchParam(queryParams);
  };

  const onSelectMemberForTransfer = (member) => {
    dispatch({
      type: SET_SELECTED_MEMBER_TRANSFER,
      payload: member,
    });
    navigate(ROUTES.MEMBER_TRANSFER_REQUEST.path);
  };

  const onSelectMember = (member) => {
    navigate(`/${ROUTES.MEMBER_DETAIL.path}/${member.memberId}`);
  };

  const onMemberStatusToggle = (member) => {
    setSelectedMember(member);
    onModalToggle();
  };

  const getTitle = () =>
    selectedMember?.status === ACTIVE
      ? "Reason for deactivating the user?"
      : "Reactivation";

  const onRefresh = () => {
    const queryObject = getQueryObject();
    const [query, params] = getQueryParams(queryObject);
    fetchSearchData(query, params);
    setMethod([]);
    setEditCollegeName("");
    setSubDivision("");
    setUniversityVal("");
    setMemberName("");
  };

  const handleGoBackToSearch = () => {
    setOpenResultModal(false);
    allowModalRef.current = false;
  };

  const handleResetAndClose = () => {
    resetFormState();
    updateSearchParam();
    setOpenResultModal(false);
    allowModalRef.current = false;
  };

  const validation = () => {
    if (!selectedDivision) {
      return "Please select Division.";
    }
    if (method.length === 0) {
      return "Please select at least one member to continue.";
    }
    return "";
  };

  const handleDivisionForm = async (e) => {
    e.preventDefault();
    try {
      const error = validation();
      if (error) throw new Error(error);
      const { divisionIdFrom, divisionIdTo } = getDivision(selectedDivision);
      await SpecialGroup.divisionGraduation({
        divisionIdFrom,
        divisionIdTo,
        members: [...method],
      });
      toast.show("Division Graduated Successfully.", AlertStatus.SUCCESS);
      setTimeout(() => {
        setMethod([]);
        onRefresh();
      }, 2000);
    } catch (err) {
      toast.show(err.message, AlertStatus.ERROR);
    }
  };

  const inductionKey = "inductionDate";
  const graduationKey = "graduationDate";

  const isPresent = method.every((item) =>
    item.hasOwnProperty(isGraduation ? graduationKey : inductionKey)
  );

  const handleGraduationForm = async (e) => {
    e.preventDefault();
    try {
      const graduationValidation = () => {
        if (method.length === 0) {
          return "Please select at least one member to continue.";
        }
        if (!isPresent) {
          return "Please enter graduation date.";
        }
        return "";
      };
      const error = graduationValidation();
      if (error) throw new Error(error);
      await SpecialGroup.graduation({
        members: [...method],
        specialGroupId: specialGroupVal,
      });
      toast.show("Graduation done Successfully.", AlertStatus.SUCCESS);
      setTimeout(() => {
        setMethod([]);
        onRefresh();
      }, 2000);
    } catch (err) {
      toast.show(err.message, AlertStatus.ERROR);
    }
  };

  const handleInductionForm = async (e) => {
    e.preventDefault();
    try {
      const inductionValidation = () => {
        if (method.length === 0) {
          return "Please select at least one member to continue.";
        }
        if (!isPresent) {
          return "Please enter induction date.";
        }
        return "";
      };
      const error = inductionValidation();
      if (error) throw new Error(error);
      await SpecialGroup.induction({
        members: [...method],
        specialGroupId: specialGroupVal,
      });
      toast.show("Induction done Successfully.", AlertStatus.SUCCESS);
      setTimeout(() => {
        setMethod([]);
        onRefresh();
      }, 2000);
    } catch (err) {
      toast.show(err.message, AlertStatus.ERROR);
    }
  };

  const handleOnClick = (e) => {
    if (isDivision === true) {
      handleDivisionForm(e);
    } else if (isGraduation === true) {
      handleGraduationForm(e);
    } else {
      return handleInductionForm(e);
    }
    return {};
  };

  const orderedFilters = filterOrder
    .map((filterKey) =>
      appliedFilters.find((filter) => filter.key === filterKey)
    )
    .filter(Boolean);

  useEffect(() => {
    getDivisions();
  }, []);

  const additionalFilters = appliedFilters.filter(
    (filter) => !filterOrder.includes(filter.key)
  );

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>

      <div style={styles.container}>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "1px",
          }}
        >
          <MuiButton
            onClick={handleResetAndClose}
            variant="outlined"
            color="secondary"
            sx={{
              textTransform: "none",
              height: "20px",
              fontSize: "13px",
              fontWeight: "600",
              marginRight: "10px",
              width: "85px",
              padding: "0px !important",
            }}
          >
            Clear Filters
          </MuiButton>
        </div>

        {/* Search Form */}
        <div style={styles.filter}>
          <form
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "12px",
              width: "100%",
            }}
            onSubmit={onSubmit}
            ref={formRef}
          >
            {/* Organization Structure */}
            <div>
              <div style={{ fontWeight: "600", marginBottom: "8px" }}>
                Organization Structure
              </div>
              <OrganizationSearch
                formRef={formRef}
                disabledOSKeys={disabledOSKeys}
              />
            </div>

            {/* Personal Details */}
            <div>
              <div style={{ fontWeight: "600", marginBottom: "8px" }}>
                Personal Details
              </div>
              <PersonalDetailsSearch
                formRef={formRef}
                disabledOSKeys={disabledOSKeys}
                isDivision={isDivision}
                onMemberIdChange={setInputMemberId}
                onMemberNameChange={setFullName}
              />
            </div>

            {/* Division & Special Group Row */}

            <div style={{ fontWeight: "600", marginBottom: "8px" }}>
              {/* ✅ Conditional heading */}
              {isDivision ? "Select Division" : "Division & Special Group"}
            </div>
            <Box
              sx={{
                // ✅ Conditional width based on isDivision
                width: isMobile
                  ? "95%"
                  : isDivision
                  ? "25%" // Desktop + isDivision = 15%
                  : "50%", // Desktop + not isDivision = 50%
                display: "grid",
                gridTemplateColumns: {
                  xs: "1fr",
                  sm: "1fr 1fr",
                  md: isDivision ? "1fr" : "1fr 1fr",
                },
                gap: 2,
              }}
            >
              {!isDivision && (
                <>
                  <AutoCompleteDropdown
                    getOptionLabel={(option) => option.shortName}
                    label="Division"
                    name="divisionId"
                    options={getOptions(divisions, "divisionId")}
                    value={divisionVal}
                    inputProps={{ required: true }}
                    onChange={(selectedValue) => {
                      if (!selectedValue) {
                        setDivisionVal("");
                        setSpecialGroupVal("");
                      } else {
                        setDivisionVal(selectedValue.value);
                        setMetaDataInRedux(
                          SET_SUB_DIVISIONS,
                          selectedValue.subDivisions
                        );
                      }
                    }}
                    useHiddenInput
                  />
                  <AutoCompleteDropdown
                    getOptionLabel={(option) => option.name}
                    name="specialGroupId"
                    options={getOptions(specialGroup, "specialGroupId")}
                    inputProps={{ required: true }}
                    value={specialGroupVal}
                    disabled={!divisionVal}
                    label="Special Group"
                    onChange={(selectedValue) => {
                      if (!selectedValue) {
                        setSpecialGroupVal("");
                      } else {
                        setSpecialGroupVal(selectedValue.value);
                      }
                    }}
                    useHiddenInput
                  />
                </>
              )}
              {isDivision && (
                <AutoCompleteDropdown
                  getOptionLabel={(option) => option.displayName}
                  label="Select Division"
                  name="division"
                  options={DIVISION_OPTIONS}
                  value={selectedDivision}
                  inputProps={{ required: true }}
                  onChange={(selectedValue) => {
                    if (!selectedValue) {
                      setSelectedDivision("");
                    } else {
                      setSelectedDivision(selectedValue.value);
                    }
                  }}
                />
              )}
            </Box>

            {/* Search Button */}
            <div
              style={{
                display: "flex",
                justifyContent: isMobile ? "center" : "flex-end",
                paddingTop: isMobile ? "20px" : "10px",
                marginRight: isMobile ? "15px" : "10px",
                paddingBottom: isMobile ? "100px" : "0px",
              }}
            >
              <MuiButton
                type="submit"
                variant="contained"
                color="primary"
                sx={{
                  width: isMobile ? "90%" : "auto",
                }}
              >
                Search
              </MuiButton>
            </div>
          </form>
        </div>
        {/* Mobile separator border - visual boundary */}
        {isMobile && (
          <div
            style={{
              borderTop: "2px solid #ffffffff",
              paddingTop: "15px",
              paddingBottom: "30px",
              marginTop: "10px",
            }}
          />
        )}

        {isLoading && <Loader />}

        {/* Search Results Modal */}
        <Modal
          open={openResultModal}
          onClose={handleGoBackToSearch}
          title="Search Results"
          customStyle={{
            marginTop: "30px",
            width: "98%",
            maxWidth: "100%",
            height: "90%",
            maxHeight: "100%",
            overflowY: "auto",
            backgroundColor: "#fff",
            display: "flex",
            flexDirection: "column",
            padding: "10px",
            position: "relative",
          }}
        >
          {isLoading ? (
            <Loader />
          ) : searchData.length > 0 ? (
            <>
              {/* Header Row */}
              <div
                style={{
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: "10px",
                  fontWeight: 600,
                  fontSize: 13,
                  marginBottom: "10px",
                  paddingBottom: "10px",
                  borderBottom: "1px solid #eee",
                }}
              >
                {/* Left: Total + Filters */}
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    minWidth: 260,
                    gap: 10,
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <div style={{ flex: "0 0 auto" }}>
                    Total Members: {paginationInfo.totalElements}
                  </div>
                  {appliedFilters.length > 0 && (
                    <div style={{ flex: 1, minWidth: 200 }}>
                      <div style={styles.filterWrapper}>
                        <div style={styles.filterContainer}>
                          {orderedFilters.map((filter) => (
                            <AppliedFilter
                              key={filter.key}
                              filter={filter}
                              onRemove={onRemoveFilter}
                            />
                          ))}
                          {additionalFilters.map((filter) => (
                            <AppliedFilterGrad
                              key={filter.key}
                              filter={filter}
                              disabled
                              onRemove={onRemoveFilter}
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* Right: Reload + Back + Clear */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    flexWrap: "wrap",
                    flex: "0 0 auto",
                  }}
                >
                  <div style={styles.reload} onClick={onRefresh}>
                    <ReloadIcon />
                  </div>
                  <MuiButton
                    onClick={handleResetAndClose}
                    variant="outlined"
                    color="secondary"
                    sx={{
                      textTransform: "none",
                      height: "32px",
                      fontSize: "13px",
                      padding: "0 14px",
                      minWidth: "100px",
                    }}
                  >
                    Clear Filters
                  </MuiButton>
                  <MuiButton
                    onClick={handleGoBackToSearch}
                    variant="contained"
                    color="primary"
                    sx={{
                      textTransform: "none",
                      height: "32px",
                      fontSize: "13px",
                      padding: "0 14px",
                    }}
                  >
                    Back
                  </MuiButton>
                </div>
              </div>

              {/* Selected Division Info */}
              {isDivision && (
                <div style={{ marginBottom: "10px" }}>
                  <Typography style={{ fontSize: "20px", color: "#484848" }}>
                    Selected Division for Graduation:{" "}
                    {getDivision(selectedDivision)?.displayName}
                  </Typography>
                </div>
              )}

              {/* Table */}
              <div style={{ flex: 1, overflowX: "auto" }}>
                <MemberTable
                  searchData={
                    isGraduation === true ? inductionData : searchData
                  }
                  onSelectMemberForTransfer={onSelectMemberForTransfer}
                  onSelectMember={onSelectMember}
                  hasPermission={hasPermission}
                  onMemberStatusToggle={onMemberStatusToggle}
                  isDivision={isDivision}
                  isGraduation={isGraduation}
                  selectionHandler={onSelectionHandler}
                  checkAllToggle={checkAllToggle}
                  selectedItems={method}
                  handleChange={handleDateChange}
                  onChangeInput={onChangeInput}
                  inductionDate={inductionDate}
                  memberName={memberName}
                  university={university}
                  universityVal={universityVal}
                  setUniversityVal={setUniversityVal}
                  setMethod={setMethod}
                  subDivision={subDivision}
                  setSubDivision={setSubDivision}
                  editCollegeName={editCollegeName}
                  setEditCollegeName={setEditCollegeName}
                  selectedDivision={selectedDivision}
                />
              </div>

              {/* Pagination + Submit */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "20px",
                  flexWrap: "wrap",
                  gap: "10px",
                }}
              >
                <div style={{ flex: 1, minWidth: "300px" }}>
                  <Pagination
                    totalPages={paginationInfo.totalPages}
                    totalResults={paginationInfo.totalElements}
                    currentPage={paginationInfo.currentPage}
                    pageSize={paginationInfo.pageSize}
                    onChange={onPaginationClick}
                    onPageSizeClick={onPageSizeClick}
                  />
                </div>
                <Button
                  label="Submit"
                  style={CommonStyles.buttonStyle}
                  onClick={(e) => handleOnClick(e)}
                />
              </div>
            </>
          ) : null}
        </Modal>

        {/* Member Status Toggle Modal */}
        <Modal open={openModal} onClose={onModalToggle} title={getTitle()}>
          <MemberToggleStatus
            selectedMember={selectedMember}
            onClose={onModalToggle}
            callBack={onRefresh}
          />
        </Modal>

        <Toast
          open={!!showToast}
          severity={showToast?.severity || ""}
          message={showToast?.message || ""}
          handleClose={() => setShowToast(null)}
        />
      </div>
    </>
  );
}

export default InductionSearch;
